import {
    ValidationResult,
} from 'app/types/form.types'

const ENDS_WITH_UNDERSCORE_NUMBER_REGEX = /.+_\d+$/

const parseError = (msg: string | string[], l: (key: string) => string) => {
    const finalMsg = Array.isArray(msg) ? msg.join(' ') : msg

    return `${l('CANNOT_PARSE_SUBMITTED_FILE')} ${finalMsg} ${l('ADJUST_FILE_TRY_AGAIN')}`
}

const validateCsv = ({
    data,
    additionalValidation,
    mandatoryHeaders = [],
    l,
}: {
    data: Record<string, any>[],
    additionalValidation?: (data: Record<string, any>[]) => ValidationResult
    mandatoryHeaders?: string[],
    l: (key: string) => string
}) => {
    if (data.length === 0) {
        return parseError(l('FILE_IS_EMPTY'), l)
    }

    let hasEmptyHeaders = false

    data.forEach((item) => {
        Object.entries(item).forEach(([
            key,
            value,
        ]) => {
            if (key.trim() === '' && value !== null) {
                hasEmptyHeaders = true
            }
        })
    })

    if (hasEmptyHeaders) {
        return parseError(l('FILE_CONTAINS_EMPTY_HEADER_NAMES'), l)
    }

    // if there are duplicated headers, parser will add _1, _2, etc. to the keys
    const hasDuplicatedHeaders = Object.keys(data[0]).some((key) => {
        return ENDS_WITH_UNDERSCORE_NUMBER_REGEX.test(key)
    })

    if (hasDuplicatedHeaders) {
        return parseError(l('FILE_CONTAINS_DUPLICATED_HEADER_NAMES'), l)
    }

    if (mandatoryHeaders.length) {
        const missingHeaders = mandatoryHeaders.filter(
            (field) => {
                return !Object.keys(data[0]).includes(field)
            },
        )

        if (missingHeaders.length) {
            return parseError(`Missing mandatory columns: ${missingHeaders.join(', ')}.`, l)
        }
    }

    if (additionalValidation) {
        const validationResult = additionalValidation(data)

        if (validationResult !== true) {
            return parseError(
                typeof validationResult !== 'boolean'
                    ? validationResult
                    : l('DATA_VALIDATION_FAILED'),
                l,
            )
        }
    }

    return true
}

export default validateCsv
